import React from 'react';

const PlanLockWrapper = ({ isLocked, children }) => {
    if (!isLocked) return children;

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ filter: 'blur(4px)', pointerEvents: 'none', userSelect: 'none', opacity: 0.4 }}>
                {children}
            </div>
            <div style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
            }}>
                <div style={{
                    background: '#0F172A',
                    borderRadius: 16,
                    padding: '40px 36px',
                    maxWidth: 420,
                    width: '90%',
                    textAlign: 'center',
                    boxShadow: '0 24px 60px rgba(0,0,0,0.6)',
                    border: '1px solid #1e3a5f',
                }}>
                    <div style={{ marginBottom: 16 }}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="5" y="11" width="14" height="10" rx="2" stroke="#f97316" strokeWidth="1.5" />
                            <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" />
                            <circle cx="12" cy="16" r="1.5" fill="#f97316" />
                        </svg>
                    </div>
                    <h3 style={{ fontSize: 18, fontWeight: 700, color: '#fff', marginBottom: 10 }}>
                        Feature Locked
                    </h3>
                    <p style={{ fontSize: 13, color: '#94A3B8', lineHeight: 1.6, marginBottom: 24 }}>
                        This module is not available on your current plan. Upgrade to unlock access.
                    </p>
                    <a
                        href="/upgrade"
                        style={{
                            display: 'inline-block',
                            background: 'linear-gradient(135deg, #f97316, #ea580c)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            padding: '10px 28px',
                            fontSize: 14,
                            fontWeight: 600,
                            textDecoration: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        Upgrade Plan
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PlanLockWrapper;
